import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { NoPictureIcon } from "../../../../data/iconImage";
import { filteredItemByArray } from "../../../../utils/ManageArray";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import {
  Card,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row
} from "react-bootstrap";
import SearchFilter from "../../../../components/SearchFilter";
import TechniciansService from "../../../../services/technician.service";

export default function TechnicianTeamInformation() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState({});
  const searchInput = [
    { name: "Tech_Mas_Code", label: "รหัสช่าง", minKeywordLength: 1 },
    { name: "Tech_Mas_Name", label: "ชื่อช่าง", minKeywordLength: 1 }
  ];
  const technician_detail = [
    { name: "Tech_Mas_Code", label: "รหัสช่าง", type: "text", size: 5 },
    { name: "Tech_Mas_Name", label: "ชื่อ-นามสกุล", type: "select" },
    { name: "Tech_Mas_Tel", label: "เบอร์โทร", type: "text" },
    { name: "Tech_Mas_Status", label: "สถานะ", type: "text" }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechniciansService.getAllTechnicians(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>รายละเอียดข้อมูลช่าง</title>
        <meta
          name="description"
          content="Detailed Technician Information Page"
        />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <SearchFilter
              data={data}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) => {
                const filteredData = filteredItemByArray(data, search);
                search?.length > 0
                  ? setFilteredData(
                      filteredData.length === 1 ? filteredData[0] : {}
                    )
                  : setFilteredData({});
              }}
            />
          </Card.Body>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Row className="m-0 p-3">
            <Col md={5} xl={4} className="px-0">
              <Card.Header className="mb-4 px-0 fs-2 text-dark bg-white">
                รายละเอียดข้อมูลช่าง
              </Card.Header>

              <Card.Body className="p-0">
                <Row>
                  {technician_detail.map(({ name, label, size }, index) => (
                    <Col key={index} sm={size || 12} className="mt-1 mb-3 fs-4">
                      <FloatingLabel controlId={name} label={label}>
                        <Form.Control
                          readOnly
                          type="text"
                          className="p-3"
                          name={name}
                          value={
                            (name === "Tech_Mas_Status"
                              ? filteredData[name] === true
                                ? "ใช้งาน"
                                : "ไม่ใช้งาน"
                              : filteredData[name]) || ""
                          }
                        />
                      </FloatingLabel>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Col>

            <Col md={2} className="px-0"></Col>

            <Col md={5} xl={4} className="px-0">
              <Card.Header className="mb-4 px-0 bg-transparent border-bottom-0">
                <Card.Title className="fs-2 text-center">รูปช่าง</Card.Title>
              </Card.Header>

              <Card.Body
                className="p-0 text-center"
                style={{ height: "22.5rem" }}
              >
                <Col
                  className={`h-100 d-flex flex-column justify-content-center align-items-center ${
                    !filteredData.Tech_Mas_Pic && "border border-secondary"
                  } rounded-4`}
                >
                  <Card.Img
                    className={filteredData.Tech_Mas_Pic ? "h-100" : "w-10"}
                    src={
                      filteredData.Tech_Mas_Pic
                        ? `${process.env.REACT_APP_STORAGE_URL}/technician-picture/${filteredData.Tech_Mas_Pic}`
                        : NoPictureIcon
                    }
                    alt={filteredData.Tech_Mas_Pic || "No Picture Icon"}
                  />

                  {!filteredData.Tech_Mas_Pic && (
                    <Card.Text className="mt-3 fs-4 text-secondary">
                      ไม่มีรูปภาพ
                    </Card.Text>
                  )}
                </Col>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
}
